import { Dialog, IconButton, Slide } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

// Transition pour l'ouverture de la modal
const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

Transition.propTypes = {
  direction: PropTypes.string,
};

const FullScreenModal = ({
  children,
  handleClose,
  open,
  title,
  titleSize = '18px',
  MontserratTitle = false,
  backgroundColor = '#ffffff',
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullScreen
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)', // Couleur du backdrop
        },
      }}
      PaperProps={{
        style: {
          backgroundColor, // Couleur de fond de la modal
          width: '100vw', // Assure que la modal couvre la largeur de l'écran
          height: '100vh', // Assure que la modal couvre la hauteur de l'écran
          margin: 0, // Supprime les marges pour une couverture complète
          borderRadius: 0, // Supprime les bords arrondis
          display: 'flex',
          flexDirection: 'column',

        },
      }}
    >
      {/* En-tête de la modal */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
          // borderBottom: '1px solid #e0e0e0',
          backgroundColor: "#0060F9",
        }}
      >
        {title && (
          <div
            style={{
              fontSize: titleSize,
              fontWeight: 700,
              color: 'white',
              fontFamily: MontserratTitle ? 'Montserrat' : 'Roboto',
            }}
          >
            {title}
          </div>
        )}
        <IconButton
          onClick={handleClose}
          style={{
            background: '#F3F7FF',
            border: '1px solid #C0D9FF',
            width: '30px',
            height: '30px',
          }}
          size="small"
        >
          <Close style={{ color: '#5A6DA1', fontSize: '15px' }} />
        </IconButton>
      </div>

      {/* Contenu de la modal */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          // padding: '24px',
        }}
      >
        {children}
      </div>
    </Dialog>
  );
};

FullScreenModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.node,
  titleSize: PropTypes.string,
  MontserratTitle: PropTypes.bool,
  backgroundColor: PropTypes.string,
};

export default FullScreenModal;
